import React from 'react';

export default function NavItem({ active, onClick, icon, label }) {
  return (
    <button 
      onClick={onClick}
      aria-current={active ? 'page' : undefined}
      aria-label={label}
      className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-all font-semibold ${
        active 
          ? 'bg-[#1b5e20] text-white shadow-lg' 
          : 'text-slate-500 hover:bg-slate-50 hover:text-slate-900'
      }`}
    >
      {icon}
      <span className="text-sm">{label}</span>
    </button>
  );
}

